import React, { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';

export const AuthModal = ({ isOpen, mode, onClose }) => {
  const { login } = useAuth();
  
  const [currentMode, setCurrentMode] = useState(mode || 'login');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [username, setUsername] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  // Сброс формы при открытии или смене режима
  useEffect(() => {
    if (isOpen) {
      setCurrentMode(mode || 'login');
      setEmail('');
      setPassword('');
      setUsername('');
      setError('');
      setSuccess('');
    }
  }, [isOpen, mode]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setLoading(true);

    try {
      if (currentMode === 'login') {
        // Вход
        const res = await fetch('https://api.retro.kf-mau.ru/auth/', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email, password })
        });
        const data = await res.json();
        
        if (!res.ok) throw new Error(data.error || 'Неверный email или пароль');

        login({ 
  pk_user: data.pk_user,
  username: data.username,
  email: data.email,
  is_admin: Boolean(data.is_admin)
}, data.token);
        
        setSuccess('Вход выполнен!');
        setTimeout(onClose, 600);
        
      } else {
        // Регистрация
        const res = await fetch('https://api.retro.kf-mau.ru/users/', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ username, email, password })
        });
        const data = await res.json();
        
        if (!res.ok) throw new Error(data.error || 'Ошибка регистрации');

        setSuccess('Аккаунт создан! Теперь войдите.');
        setTimeout(() => {
          setCurrentMode('login');
          setSuccess('');
          setEmail('');
          setPassword('');
          setUsername('');
        }, 1000);
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay active" onClick={onClose}>
      <div className="modal-card" onClick={e => e.stopPropagation()}>
        <div className="modal-close" onClick={onClose} />
        
        <h2 className="modal-title">
          {currentMode === 'login' ? 'Вход в архив' : 'Регистрация'}
        </h2>

        <form onSubmit={handleSubmit}>
          {currentMode === 'register' && (
            <div className="form-group">
              <label className="form-label">Имя пользователя</label>
              <input
                className="form-input"
                type="text"
                value={username}
                onChange={e => setUsername(e.target.value)}
                required
                autoComplete="username"
                placeholder="Ваше имя"
              />
            </div>
          )}

          <div className="form-group">
            <label className="form-label">Email</label>
            <input
              className="form-input"
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
              autoComplete="email"
              placeholder="example@mail.com"
            />
          </div>

          <div className="form-group">
            <label className="form-label">Пароль</label>
            <input
              className="form-input"
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
              autoComplete={currentMode === 'login' ? 'current-password' : 'new-password'}
              placeholder="••••••••"
            />
          </div>

          {error && <div className="form-message error">{error}</div>}
          {success && <div className="form-message success">{success}</div>}

          <button 
            className="form-btn" 
            type="submit" 
            disabled={loading}
          >
            {loading ? 'Загрузка...' : (currentMode === 'login' ? 'Войти' : 'Зарегистрироваться')}
          </button>
        </form>

        <div className="form-switch">
          {currentMode === 'login' ? 'Нет аккаунта? ' : 'Уже есть аккаунт? '}
          <span 
            onClick={() => {
              setCurrentMode(prev => prev === 'login' ? 'register' : 'login');
              setError(''); 
              setSuccess('');
            }}
          >
            {currentMode === 'login' ? 'Регистрация' : 'Вход'}
          </span>
        </div>
      </div>
    </div>
  );
};